import RequestedDocuments from './RequestedDocuments';
import {
  setCameraMode,
  setPrivacyAccepted
} from '../../redux/actions/rootAction';
import {
  DOCUMENT_DISPLAY_MODE_DESKTOP_WINDOW,
  DOCUMENT_DISPLAY_MODE_INPAGE,
  DOCUMENT_DISPLAY_MODE_MOBILE_WINDOW
} from '../helpers/utils';
import { xconnect } from '../../redux/xconnect';

const mapStateToProps = (state, ownProps) => {
  const scanEnded = state.scanEnded || state.submitted;

  return {
    requesterSelfMode: state.requesterSelfMode,
    embedMode: state.embedMode,
    hideNavigation: state.hideNavigation,
    skipStartPage: state.skipStartPage,
    skipStartPageOriginal: state.skipStartPageOriginal,
    visitedDocuments: state.visitedDocuments,
    selectedLang: state.selectedLang,
    brandingDetails: state.brandingDetails,
    cameraMode: state.cameraMode,
    caseName: state.caseName,
    companyEmail: state.companyEmail,
    companyName: state.companyName,
    documentsStatus: state.documentsStatus,
    errorMessage: state.errorMessage,
    expired: state.expired,
    forms: state.forms,
    infoMessage: state.infoMessage,
    emailMessage: state.emailMessage,
    requestMessage: state.requestMessage,
    completeButtonLabel: state.completeButtonLabel,
    customConfirmationPageText: state.customConfirmationPageText,
    companyLogo: state.companyLogo,
    privacyAccepted: true, //state.privacyAccepted
    scanEnded,
    scannedDocuments: state.scannedDocuments,
    showThankyouPopUp: ownProps.showThankyouPopUp,
    submittedDate: state.submittedDate,
    successSentKeys: state.successSentKeys,
    errorSentKeys: state.errorSentKeys,
    templateMode: state.templateMode,
    currentRequestPageIndex: state.currentRequestPageIndex,
    requestStepMovedForward: state.requestStepMovedForward,
    sendSignal: ownProps.sendSignal,
    activeDocumentSharedState: state.activeDocumentSharedState,
    oneDocumentMode: state.oneDocumentMode,
    displayMode:
      state.requestPages && window.isDesktop
        ? DOCUMENT_DISPLAY_MODE_INPAGE
        : window.isDesktop
        ? DOCUMENT_DISPLAY_MODE_DESKTOP_WINDOW
        : DOCUMENT_DISPLAY_MODE_MOBILE_WINDOW
  };
};

const mapDispatchToProps = dispatch => ({
  setCameraMode: as => dispatch(setCameraMode(as)),
  setPrivacyAccepted: as => dispatch(setPrivacyAccepted(as))
});

export default xconnect(
  mapStateToProps,
  mapDispatchToProps
)(RequestedDocuments);
